// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1WLE2","consentsList":"PatientConsents_consentsList__2PRnJ","consentsListEmpty":"PatientConsents_consentsListEmpty__2dQ9p"};